module.exports = __webpack_public_path__ + "img/slide2.0d7f0f76.svg";